import React from 'react';

//compoennts
import { Video, VideoProps } from 'src/components/common/modules/video-player/video';

//types
import { HeroBackgroundVideoProps } from '../../typings';

const HeroBgVideo: React.FC<HeroBackgroundVideoProps> = (props) => {
  const { videoFileUrl, videoPoster, heroScrollDownArrow  , hideSoundControlsForVideo} = props;
  const videoProps: VideoProps = {
    src: videoFileUrl?.[0]?.url,
    exClass: 'hero-bg-video-component',
    autoPlay: true,
    muted: true,
    loop: true,
    poster: videoPoster?.[0]?.url,
    playsInline: true,
    heroScrollDownArrow: (heroScrollDownArrow === 'True') ? true : false,
    hideSoundControlsForVideo : hideSoundControlsForVideo === "True" ? true : false
  };

  return <Video {...videoProps} />;
};


export default HeroBgVideo

